import { z } from 'zod';

import { ImageLoading } from './image-loading';

export const PictureData = z.object({
  pngSrc: z.string(),
  webpSrc: z.string().optional(),
  altText: z.string().optional(),
  loading: z.optional(ImageLoading),
  preload: z.boolean().optional(),
  style: z.string().optional(),
  addClass: z.string().optional(),
  height: z.number().optional(),
  width: z.number().optional(),
  imageId: z.string().optional(),
});

export type PictureData = z.infer<typeof PictureData>;
